import InspectionElement from "./InspectionElement";
import { AssetType } from "./AssetType";
import SurveyorCompletionStatus from "./SurveyorCompletionStatus";
import { ImageDeleteData } from "./ImageDeleteData";
import { CarbonSectionData } from "./CarbonSection";
import { DefectItem } from "./DefectItem";

export interface Inspection {
    CreatedAt: string;
    Id: string;
    InspectionNumber: string;
    InspectionStart: string;
    InspectionEnd: string;
    InspectionLocation: string;
    MainShipImage: string;
    ShipName: string;
    ShipIMO: string;
    Status: number;
    InspectionStatus: string;
    InspectionTypeId: number;
    InspectionType: string;
    InspectionCompletedEndAt: string;
    DueDate: string;
    NumberOfDocuments: number;
    NumberOfPhotos: number;
    sections: InspectionElement[];
    localUpdateTime: string;
    SurveyorCompletionStatus: SurveyorCompletionStatus;
    NumberOfChecklists: number;
    DateTimeFrom: string;
    ImageDeleteMode: boolean;
    ImageDeleteList: ImageDeleteData[];
    CarbonSectionData: CarbonSectionData;
    ChecklistElementsCount: number;
    DocumentElementsCount: number;
    ImageElementsCount: number;
    NotesForSurveyor: string | null;
    OrganizationId: number;
    DocumentReuseStatus: DocumentReuseStatus | null;
    inspectionTypeAllowedReuse: boolean;
    AssetType: AssetType;
    FeatureFlags: any;
    defects: DefectItem[];
}

export enum Type {
    "Pre Purchase Inspection" = 1,
    "Condition Inspection" = 2,
    "Pre Charter Inspection" = 3,
    "Owners Inspection" = 4,
    "Flag State Inspection" = 5,
    "P&I Inspection" = 6,
    "Cruise Vessel Pre-Purchase Inspection" = 7,
    "Cruise Vessel Condition Inspection" = 8,
    "Vetting" = 9,
    "Desktop Review" = 10,
    "Pre-docking inspection" = 11,
    "Hoegh Autoliners Pre-Docking Condition Inspection" = 12,
    "Pre-Sale Inspection" = 13,
    "Affiliate Vetting" = 14
}

export enum Status {
    "New" = 1,
    "Bidding" = 2,
    "Upcoming" = 3,
    "Confirmed" = 4,
    "Inspection Completed" = 5,
    "Preliminary Repor" = 6,
    "Full Report" = 7,
    "Cancelled" = 9
}

export function getCheckListCount(inspection: Inspection) {
    let checkListsCount = 0;
    for (let i = 0; i !== inspection.sections.length; i++) {
        if (inspection.sections[i].ElementType === AssetType.CheckList) {
            checkListsCount += inspection.sections[i].checkList.assets.length;
        }
    }
    return checkListsCount;
}

export enum DocumentReuseStatus {
    NOT_SELECTED = 0,
    RE_USE = 1,
    NOT_RE_USE = 2
}
